const parseCssTime = (value) => {
	const trimmed = (value || '').trim()
	if (trimmed.endsWith('ms')) return Number.parseFloat(trimmed) || 0
	if (trimmed.endsWith('s')) return (Number.parseFloat(trimmed) || 0) * 1000
	return Number.parseFloat(trimmed) || 0
}

const getTransitionWindowMs = (element) => {
	const style = window.getComputedStyle(element)
	const durations = style.transitionDuration.split(',').map(parseCssTime)
	const delays = style.transitionDelay.split(',').map(parseCssTime)
	const length = Math.max(durations.length, delays.length)
	let max = 0
	for (let i = 0; i < length; i++) {
		max = Math.max(max, (durations[i] || durations[durations.length - 1] || 0) + (delays[i] || delays[delays.length - 1] || 0))
	}
	return max
}

const lockRevealRearm = (element) => {
	element.dataset.layRevealLockedUntil = Date.now() + getTransitionWindowMs(element) + 100
}

const isRevealRearmLocked = (element) => {
	const lockedUntil = Number.parseFloat(element.dataset.layRevealLockedUntil || '0')
	return lockedUntil > Date.now()
}

const showElementInView = (element) => {
	element.classList.remove('below')
	element.classList.add('in-view')
	lockRevealRearm(element)
}

const setElementBelow = (element) => {
	delete element.dataset.layRevealLockedUntil
	element.style.transitionDelay = ''
	element.classList.add('below')
	element.classList.remove('in-view')
}

export {
	isRevealRearmLocked,
	lockRevealRearm,
	setElementBelow,
	showElementInView,
}
